export const SET_INITIAL_USER_TOKEN = "SET_INITIAL_USER_TOKEN";
export const ERROR_SET_INITIAL_USER_TOKEN = "ERROR_SET_INITIAL_USER_TOKEN";
export const CHANGE_USER_TOKEN_AND_CURRENT_WORKSPACE =
  "CHANGE_USER_TOKEN_AND_CURRENT_WORKSPACE";
export const CHECK_USER_RIGHTS = "CHECK_USER_RIGHTS";

export const CURATED_REGHUB_TOPICS_ARE_LOADING =
  "CURATED_REGHUB_TOPICS_ARE_LOADING";
export const CURATED_REGHUB_TOPICS_LOADED_WITH_ERROR =
  "CURATED_REGHUB_TOPICS_LOADED_WITH_ERROR";
export const CURATED_REGHUB_TOPICS_HAVE_LOADED =
  "CURATED_REGHUB_TOPICS_HAVE_LOADED";

export const GET_SINGLE_CURRENT_TOPIC_IS_LOADING =
  "GET_SINGLE_CURRENT_TOPIC_IS_LOADING";
export const GET_SINGLE_CURRENT_TOPIC_LOADED_WITH_ERROR =
  "GET_SINGLE_CURRENT_TOPIC_LOADED_WITH_ERROR";
export const GET_SINGLE_CURRENT_TOPIC_IS_LOADED =
  "GET_SINGLE_CURRENT_TOPIC_IS_LOADED";

export const USER_REGISTRATION_IS_LOADING = "USER_REGISTRATION_IS_LOADING";
export const USER_REGISTRATION_IS_LOADED_WITH_ERROR =
  "USER_REGISTRATION_IS_LOADED_WITH_ERROR";
export const USER_REGISTRATION_IS_LOADED = "USER_REGISTRATION_IS_LOADED";

export const USER_LOGGING_IS_LOADING = "USER_LOGGING_IS_LOADING";
export const USER_LOGGING_IS_LOADED_WITH_ERROR =
  "USER_LOGGING_IS_LOADED_WITH_ERROR";
export const USER_LOGGING_IS_LOADED = "USER_LOGGING_IS_LOADED";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";

export const SUBSCRIBE_TO_TOPIC = "SUBSCRIBE_TO_TOPIC";
export const UNSUBSCRIBE_TO_TOPIC = "UNSUBSCRIBE_TO_TOPIC";
export const RESTART_TOPIC_MESSAGES = "RESTART_TOPIC_MESSAGES";
export const TOPIC_SUCCESS_MESSAGE_RAISED = "TOPIC_SUCCESS_MESSAGE_RAISED";
export const TOPIC_ERROR_MESSAGE_RAISED = "TOPIC_ERROR_MESSAGE_RAISED";

export const FILTERS_ARE_LOADING = "FILTERS_ARE_LOADING";
export const FILTERS_LOADED_WITH_ERROR = "FILTERS_LOADED_WITH_ERROR";
export const FILTERS_ARE_LOADED = "FILTERS_ARE_LOADED";
export const FILTER_SUCCESS_MESSAGE_RAISED = "FILTER_MESSAGE_RAISED";
export const FILTER_FAILURE_MESSAGE_RAISED = "FILTER_FAILURE_MESSAGE_RAISED";
export const FILTER_MESSAGES_RESTARTED = "FILTER_MESSAGES_RESTARTED";
export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER";

export const REGULATORY_STREAM_ARE_LOADING = "REGULATORY_STREAM_ARE_LOADING";
export const REGULATORY_STREAM_LOADED_WITH_ERROR =
  "REGULATORY_STREAM_LOADED_WITH_ERROR";
export const REGULATORY_STREAM_ARE_LOADED = "REGULATORY_STREAM_ARE_LOADED";
export const DELETE_NEWS_BY_ID_FROM_REGULATORY_STREAM =
  "DELETE_NEWS_BY_ID_FROM_REGULATORY_STREAM";

export const TOP_5_PUBLISHERS_ARE_LOADING = "TOP_5_PUBLISHERS_ARE_LOADING";
export const TOP_5_PUBLISHERS_LOADED_WITH_ERROR =
  "TOP_5_PUBLISHERS_LOADED_WITH_ERROR";
export const TOP_5_PUBLISHERS_ARE_LOADED = "TOP_5_PUBLISHERS_ARE_LOADED";

export const TOP_5_COUNTRIES_ARE_LOADING = "TOP_5_COUNTRIES_ARE_LOADING";
export const TOP_5_COUNTRIES_LOADED_WITH_ERROR =
  "TOP_5_COUNTRIES_LOADED_WITH_ERROR";
export const TOP_5_COUNTRIES_ARE_LOADED = "TOP_5_COUNTRIES_ARE_LOADED";

export const HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADING =
  "HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADING";
export const HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED_WITH_ERROR =
  "HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED_WITH_ERROR";
export const HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED =
  "HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED";

export const GRAPH_AGGREGATION_ARE_LOADING = "GRAPH_AGGREGATION_ARE_LOADING";
export const GRAPH_AGGREGATION_ARE_LOADED_WITH_ERROR =
  "GRAPH_AGGREGATION_ARE_LOADED_WITH_ERROR";
export const GRAPH_AGGREGATION_ARE_LOADED = "GRAPH_AGGREGATION_ARE_LOADED";

export const GRAPH_AGGREGATION_DETAILS_ARE_LOADING =
  "GRAPH_AGGREGATION_DETAILS_ARE_LOADING";
export const GRAPH_AGGREGATION_DETAILS_ARE_LOADED_WITH_ERROR =
  "GRAPH_AGGREGATION_DETAILS_ARE_LOADED_WITH_ERROR";
export const GRAPH_AGGREGATION_DETAILS_ARE_LOADED =
  "GRAPH_AGGREGATION_DETAILS_ARE_LOADED";

export const GET_DOCUMENT_IS_LOADING = "GET_DOCUMENT_IS_LOADING";
export const GET_DOCUMENT_IS_LOADED_WITH_ERROR =
  "GET_DOCUMENT_IS_LOADED_WITH_ERROR";
export const GET_DOCUMENT_IS_LOADED = "GET_DOCUMENT_IS_LOADED";

export const GET_SIMILAR_DOCUMENT_IS_LOADED = "GET_SIMILAR_DOCUMENT_IS_LOADED";
export const GET_SIMILAR_DOCUMENT_IS_LOADING =
  "GET_SIMILAR_DOCUMENT_IS_LOADING";
export const GET_SIMILAR_DOCUMENT_IS_LOADED_WITH_ERROR =
  "GET_SIMILAR_DOCUMENT_IS_LOADED_WITH_ERROR";

export const FILTERS_TYPES_ARE_LOADING = "FILTERS_TYPES_ARE_LOADING";
export const FILTERS_TYPES_LOADED_WITH_ERROR =
  "FILTERS_TYPES_LOADED_WITH_ERROR";
export const FILTERS_TYPES_ARE_LOADED = "FILTERS_TYPES_RE_LOADED";

export const TILES_ARE_LOADING = "TILES_ARE_LOADING";
export const TILES_HAVE_BEEN_LOADED_WITH_ERROR =
  "TILES_HAVE_BEEN_LOADED_WITH_ERROR";
export const TILES_HAVE_LOADED = "TILES_HAVE_LOADED";

export const CLEAR_TILES = "CLEAR_TILES";

export const GET_SINGLE_TILE_IS_LOADING = "GET_SINGLE_TILE_IS_LOADING";
export const GET_SINGLE_TILE_IS_LOADED_WITH_ERROR =
  "GET_SINGLE_TILE_IS_LOADED_WITH_ERROR";
export const GET_SINGLE_TILE_IS_LOADED = "GET_SINGLE_TILE_IS_LOADED";

export const TILES_OF_TYPE_LINKS_ARE_LOADING =
  "TILES_OF_TYPE_LINKS_ARE_LOADING";
export const TILES_OF_TYPE_LINKS_HAVE_BEEN_LOADED_WITH_ERROR =
  "TILES_OF_TYPE_LINKS_HAVE_BEEN_LOADED_WITH_ERROR";
export const TILES_OF_TYPE_LINKS_HAVE_LOADED =
  "TILES_OF_TYPE_LINKS_HAVE_LOADED";

export const TILE_TYPE_LIST_IS_LOADING = "TILE_TYPE_LIST_IS_LOADING";
export const TILE_TYPE_LIST_IS_LOADED = "TILE_TYPE_LIST_IS_LOADED";
export const TILE_TYPE_LIST_IS_LOADED_WITH_ERROR =
  "TILE_TYPE_LIST_IS_LOADED_WITH_ERROR";

export const TILES_SUCCESS_MESSAGE_RAISED = "TILES_SUCCESS_MESSAGE_RAISED";
export const TILES_ERROR_MESSAGE_RAISED = "TILES_ERROR_MESSAGE_RAISED";
export const TILES_RESTART_MESSAGES = "TILES_RESTART_MESSAGES";

export const CRAWLER_SOURCES_ARE_LOADING = "CRAWLER_SOURCES_ARE_LOADING";
export const CRAWLER_SOURCES_LOADED_WITH_ERROR =
  "CRAWLER_SOURCES_LOADED_WITH_ERROR";
export const CRAWLER_SOURCES_ARE_LOADED = "CRAWLER_SOURCES_ARE_LOADED";
export const CRAWLER_SOURCES_SUCCESS_MESSAGE =
  "CRAWLER_SOURCES_SUCCESS_MESSAGE";
export const PREVIEWED_CRAWLER_SOURCE_SUCCESSFULLY =
  "PREVIEWED_CRAWLER_SOURCE_SUCCESSFULLY";

export const ADD_NEWS_ITEM = "ADD_NEWS_ITEM";
export const EDIT_NEWS_ITEM = "EDIT_NEWS_ITEM";
export const GENERATE_NEWS_ITEM = "GENERATE_NEWS_ITEM";
export const ADD_TO_ARRAY = "ADD_TO_ARRAY";
export const ADD_PAGE = "ADD_PAGE";

export const REGULATORY_STREAM_ARE_CLEAN = "REGULATORY_STREAM_ARE_CLEAN";

export const GET_ADITIONAL_TILES = "GET_ADITIONAL_TILES";

export const UPDATE_TILE_ARR = "UPDATE_TILE_ARR";

export const SET_ADDITIONAL_PARAMS = "SET_ADDITIONAL_PARAMS";

export const SET_SUBSCRIPTION_FREQUENCY = "SET_SUBSCRIPTION_FREQUENCY";

export const SET_SUBSCRIPTION_TYPES = "SET_SUBSCRIPTION_TYPES";

export const AI_QUESTION_ERROR_MESSAGE_RAISED =
  "AI_QUESTION_ERROR_MESSAGE_RAISED";

export const AI_QUESTION_HAVE_BEEN_LOADED_WITH_ERROR =
  "AI_QUESTION_HAVE_BEEN_LOADED_WITH_ERROR";

export const AI_RESPONSE_HAVE_LOADED = "AI_RESPONSE_HAVE_LOADED";

export const AI_RESPONSE_ARE_LOADING = "AI_RESPONSE_ARE_LOADING";

export const AI_RESPONSE_CLOSE_MODAL = "AI_RESPONSE_CLOSE_MODAL";
